module.exports = __webpack_public_path__ + "static/media/aww.a159ab15.ogg";